import {
  ASSIGNMENT_TREATMENT_INSTANCE_GET_SUCCESS,
  RESET_ASSIGNMENT_INFO,
  SCHEDULER_MODE_VIEW_CHANGE,
} from '../../../actions/constants/types';

const initialState = {
  description: '',
  timeSlots: [],
};

const assignmentInfo = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGNMENT_TREATMENT_INSTANCE_GET_SUCCESS:
      return {
        ...state,
        description: action.response.data.description,
        timeSlots: [...action.response.data.timeSlots],
      };
    case RESET_ASSIGNMENT_INFO:
      return {
        ...state,
        description: '',
        timeSlots: [],
      };
    case SCHEDULER_MODE_VIEW_CHANGE:
      return {
        ...state,
        description: '',
        timeSlots: [],
      };
    default:
      return state;
  }
};

export default assignmentInfo;
